import { mapAxiosResponse } from '../../shared/utils/api-utils';
import mapResponseOnUserInfo, { UserInfo, UserInfoResponse } from '../../shared/models/user';
import EnrouteApiClient from '../../shared/services/enroute-api-client';

export default class OrgService {
  static async getOrgUsers(orgId?: number, includeChildren?: boolean): Promise<UserInfo[]> {
    const resp = await EnrouteApiClient.post(`org/${ orgId }/agents`, null, {
      params: {
        // Sometimes we create Glympse controller users for managing accounts and we want to make sure our
        // customers are not interacting with these users
        exclude_tag: "glympse",
        avatar: true, // TODO: unable to load agent list with avatar=true
        include_removed: true,
        children: includeChildren || false
      },
    });

    return (mapAxiosResponse<UserInfoResponse[]>(resp) || []).map((userInfo) => mapResponseOnUserInfo(userInfo));
  }
}
